import styled from "styled-components";

export const Right = styled("p")`
  font-size: 12px;
  font-weight:600;
  text-transform: capitalize;
  color: #000;
  text-align:center;
  font-family:"arial";

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;